import React, { useCallback } from "react";
import { GeoJSONFeatureCollection } from "../types";

interface ResultComponentProps {
  fetchedRoutes: GeoJSONFeatureCollection | null;
  randomRouteCount: number;
}

interface ProviderStatsProps {
  provider: string;
  successCount: number;
  totalCount: number;
}

const ProviderStats: React.FC<ProviderStatsProps> = ({
  provider,
  successCount,
  totalCount,
}) => (
  <li className="provider-stats">
    <strong>{provider}:</strong> <span style={{ float: 'right' }}>{successCount}/{totalCount} successful</span>
  </li>
);

const ResultComponent: React.FC<ResultComponentProps> = ({
  fetchedRoutes,
  randomRouteCount,
}) => {
  const downloadGeoJSON = useCallback(() => {
    if (!fetchedRoutes) return;

    const blob = new Blob([JSON.stringify(fetchedRoutes)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "routes.geojson";
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 0);
  }, [fetchedRoutes]);

  if (!fetchedRoutes) return null;

  return (
    <section className="results-container">
      <ul className="success-stats">
        {Object.entries(fetchedRoutes.properties?.success_stats || {}).map(
          ([provider, successes]) => (
            <ProviderStats
              key={provider}
              provider={provider}
              successCount={successes}
              totalCount={randomRouteCount}
            />
          )
        )}
      </ul>
      <button onClick={downloadGeoJSON} className="download-button">
        Download routes as GeoJSON
      </button>
    </section>
  );
};

export default ResultComponent;
